import React from 'react';

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    name?: string;
    disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    checked,
    onChange,
    name,
    disabled = false
}) => {
    return (
        <label className="relative inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                name={name}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className="sr-only peer"
                disabled={disabled}
            />
            <div className={`
                w-11 h-6 
                rounded-full 
                relative
                transition-all
                duration-300
                ease-in-out
                ${checked ? 'bg-green-600' : 'bg-gray-200'}
                ${disabled ? 'bg-gray-300' : ''}
            `}>
                <span className={`
                    absolute 
                    top-0.5 left-0.5 
                    bg-gray-100
                    rounded-full 
                    h-6 
                    w-6
                    transform
                    transition-all
                    duration-300
                    ease-in-out
                    shadow-sm
                    ${checked ? 'translate-x-5' : 'translate-x-0'}
                `} />
            </div>
        </label>
    );
};

export default ToggleSwitch;